<script setup lang="ts">
const props = defineProps<{
  overlay?: Overlay
}>()

const { frontPages } = useGlobalState()

const route = useRoute()
const link = computed<LinkProps>(() => {
  return {
    title: props.overlay?.title || props.overlay?.page?.title,
    url:
      route.path === '/'
        ? '' + props.overlay?.page?.url?.replace('/page', '')
        : frontPages.value.getStarted.slug + props.overlay?.page?.url?.replace('/page', ''),
    target: '_self',
  }
})

const hasContent = computed(() => !!(props.overlay?.subHeading || props.overlay?.subHeading))
</script>

<template>
  <div
    class="bg-neon-yellow pointer-events-auto relative flex flex-col p-4"
    :class="{
      'w-[315px] max-2xl:aspect-[3/4] lg:max-h-[55vh] 2xl:min-h-80': hasContent,
      'w-full': !hasContent,
    }"
  >
    <div v-if="overlay?.subHeading" class="text-lg">
      <ElementsPortableTextWrapper :content="overlay.subHeading" />
    </div>
    <div v-if="overlay?.text" class="pt-7 text-base">
      <ElementsPortableTextWrapper :content="overlay.text" />
    </div>
    <ElementsLogomarkLink class="mt-auto" :make-container-clickable="true" :link="link" />
  </div>
</template>
